import failedCheckIcon from '../../images/failed-check.svg';

import { ErrorCategory, UnderwritingContext } from 'kashable-mobile-common';

import { ErrorData } from '../hooks/useError';

export const UNKNOWN_ERROR = 'Something went wrong';
const DEFAULT_MESSAGE =
    'Please keep in mind you might still be eligible for a Kashable credit, you can proceed to Loan Application (This may affect your credit rate)';
const ERROR_MESSAGE = `Thank you for your interest in the Kashable Loan Program. <b>As a reminder, checking your rate did not affect your credit score with the major credit bureaus.</b>`;

export const getEstimateErrorData = (msg?: string): ErrorData => {
    const messages = [ERROR_MESSAGE];

    messages.push(msg ? msg : DEFAULT_MESSAGE);

    return {
        title: 'Unfortunately...',
        messages,
        icon: failedCheckIcon,
    };
};

export const getAuthorizationErrorData = (
    messages: string[],
    uec?: UnderwritingContext,
    errorCategory?: ErrorCategory,
): ErrorData => {
    const defaultMsg =
        errorCategory === 'UW'
            ? 'After carefully reviewing your information, we are sorry to advise you that you do not meet our underwriting criteria at this time.'
            : 'After carefully reviewing your information, we are sorry to advise you that you cannot continue with the credit application at this time.';

    messages.unshift(uec === 'PREQUALIFY' ? ERROR_MESSAGE : defaultMsg);

    return {
        title: 'Unfortunately...',
        messages,
    };
};

export const getLoginError = (error: string): string => {
    switch (error) {
        case 'c2':
            return 'Your account has been locked for your protection due to too many incorrect password attempts. Please contact Kashable Support.';
        case 's1':
            return 'System is down for maintenance';
        case 'c3':
            return 'Your password has been locked. Please change your password and then try again.';
        case 'c4':
            return 'Your account has been locked for your protection due to too many incorrect mfa attempts. Please contact Kashable Support.';
        case 'c1':
        default:
            return 'Unrecognized login entered. Please try again.';
    }
};
